// Only 'dev' may write missing keys: any build with saveMissing ships a write-enabled Locize API key to the browser.
export const LOCIZE_SAVE_MISSING_ENV_ALLOWLIST: string[] = ['dev'];

// Builds served from a developer's machine must never write to Locize, even with ENV=dev (npm run start:dev).
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '0.0.0.0', '[::1]'];

// Gates every Locize write (saveMissing and locize-lastused).
export const shouldSaveMissing = (
  environment?: string,
  hostname?: string,
): boolean => {
  const normalizedEnvironment = (environment || '').toLowerCase();
  const normalizedHostname = (hostname || '').toLowerCase();

  if (!normalizedEnvironment || !normalizedHostname) {
    return false;
  }

  return (
    LOCIZE_SAVE_MISSING_ENV_ALLOWLIST.includes(normalizedEnvironment) &&
    !LOCAL_HOSTNAMES.includes(normalizedHostname)
  );
};
